// extracted by mini-css-extract-plugin
export default {"AddFaqCategoryPopup":"UpdateFaqCategory_AddFaqCategoryPopup__eiIAt","Custom-Header":"UpdateFaqCategory_Custom-Header__yPwIv","Option-Button":"UpdateFaqCategory_Option-Button__JD+0a"};